import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { CmsConfig } from '../../../../../cms/src/lib/config/cms.config';

@Component({
  selector: 'kion-checkout-header',
  templateUrl: './checkout-header.component.html',
  styleUrls: ['./checkout-header.component.scss']
})
export class CheckoutHeaderComponent implements OnInit {

  @Input() addressUrl: string;
  @Input() deliveryUrl: string;
  @Input() paymentUrl: string;
  @Input() summaryUrl: string;

  checkoutBaseRoute: string;

  constructor(private route: ActivatedRoute, private cmsConfig: CmsConfig) {
    this.checkoutBaseRoute = this.cmsConfig.routes?.checkoutBaseRoute;
  }

  ngOnInit(): void { }

  isUrl(urlString: string): boolean {
    return this.route.snapshot.url.map(url => url.path).includes(urlString)
  }
}
